// extracted by mini-css-extract-plugin
export default {"PhotoTitleEditForm__submitBtn":"iw_a bhf_sq","PhotoTitleEditForm__cancelBtn":"iw_b bhf_su bhf_st"};